export const Capitalize = (str = "") => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function limitString(text, limit = 10, addDots = false) {
    if (!text) return "";
    const words = text.split(" ");
    const truncated = words.slice(0, limit).join(" ");
    return truncated + (words.length > limit && addDots ? "..." : "");
}

export const formatNumber = (number, prefix = "", suffix = "", minDecimals = 2, maxDecimals = 2) => {
    if (!number) {
        number = 0;
    }
    number = parseFloat(number);
    number = number.toLocaleString('en-GB', {
        minimumFractionDigits: minDecimals,
        maximumFractionDigits: maxDecimals,
    });
    if (prefix) {
        number = prefix + " " + number;
    }
    if (suffix) {
        number = number + suffix;
    }
    return number;
}